import '../app/globals.css';
import { ClerkProvider } from '@clerk/nextjs';
import { SWRConfig } from 'swr';
import RouteProgress from '@/features/dashboard/RouteProgress';
import { swrConfig } from '@/modules/utils/fetch-data';

export default function App({ Component, pageProps }) {
	const getLayout = Component.getLayout ?? ((page) => page);

	return (
		<ClerkProvider data-sentry-element="ClerkProvider" data-sentry-component="App" data-sentry-source-file="_app.jsx">
			<SWRConfig value={swrConfig} data-sentry-element="SWRConfig" data-sentry-source-file="_app.jsx">
				<RouteProgress data-sentry-element="RouteProgress" data-sentry-source-file="_app.jsx" />
				{getLayout(<Component {...pageProps} />, pageProps)}
			</SWRConfig>
		</ClerkProvider>
	);
}
